import { useGetConfigurationQuery } from '@/app/api/resourceApi';
import { useGetDeliveryConfigQuery } from '@/features/checkout/deliveryApi';

/**
 * SC-1274 — le carnet ne montre la vue « Livraison » qu'a un restaurant qui
 * livre vraiment : le module (`enable_livraison`, resource) ET une
 * configuration de livraison active (`DeliveryConfig.enabled`, sale). Les deux
 * sont exiges a la commande (SC-570), donc sans l'un des deux aucune
 * livraison n'arrive.
 *
 * Ferme tant qu'on ne sait pas, et ferme si l'une des requetes echoue — a
 * l'inverse de `useAllowedModes`, qui reste ouvert en cas d'echec : ici le
 * prix d'un « non » a tort est nul (les livraisons restent listees dans
 * « En ligne », comme avant), alors qu'un « oui » a tort changerait l'ecran
 * d'un restaurant qui ne livre pas. `currentData` pour la meme raison que
 * dans `useAllowedModes`.
 */
export function useWaiterDeliveryEnabled(restaurantUuid: string): boolean {
  const { currentData: config } = useGetConfigurationQuery(restaurantUuid, { skip: !restaurantUuid });
  const { currentData: deliveryConfig } = useGetDeliveryConfigQuery(restaurantUuid, {
    skip: !restaurantUuid,
  });
  return config?.modes?.includes('delivery') === true && deliveryConfig?.enabled === true;
}
